module.exports = __webpack_public_path__ + "static/media/700.8b017f77.svg";